// extracted by mini-css-extract-plugin
export default {"CTAContainer":"ThirdPartyCTA_CTAContainer__u7yoR"};